import React, { useState } from "react"
import ModalCustom from "components/ModalCustom"
import alertSvg from "images/alert.svg"
import { Select, Form, Input } from "antd"
import { flatMap } from "lodash"

const ModalInvite = (props) => {
  const [loading, setLoading] = useState(false)
  const [actual_language, setActualLanguage] = useState(undefined)

  const save = async () => {
    setLoading(true)
    try {
      const result = await fetchGlobalApi({
        method: "POST",
        endpoint: "ambassadors/invite",
        data: {
          id_language: actual_language,
          ambassadors: flatMap(props.usersSelected, (item) => {
            return { id_ambassador: item.id_ambassador }
          }),
        },
      })
      setLoading(false)
      returnMessage(result)
      props.onFinish(true)
    } catch (error) {
      returnMessage(error)
    }
    setLoading(false)
  }
  const handleChangeLanguage = (value) => {
    setActualLanguage(value)
  }
  const header = () => {
    const userSelecteds = props.usersSelected

    if (userSelecteds.length === 1) {
      return (
        <>
          <b className="component-deletesimple__title">
            ¿Estás seguro de que deseas enviar el correo de <br /> invitación a{" "}
            {userSelecteds[0].first_name} {userSelecteds[0].last_name}?
          </b>
          <div style={{fontWeight: "normal", margin: "0 auto"}}>
          <Input.Group >
            <Form.Item style={{ width: "100%", textAlign: "left", float: "left", marginTop: "5px", fontWeight:"normal" }}>
              <Select 
                placeholder="Seleccionar idioma del correo"
                value={actual_language}
                style={{ width: "100%", textAlign: "left", float: "left",  fontWeight:"normal" }}
                onChange={handleChangeLanguage}>
                {/*  <Option value="Español">Español</Option> */}
                {props.languages?.map((language) => (
                  <Select.Option
                    key={`language-${language.id_language}`}
                    value={language.id_language}>
                    {language.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Input.Group>
          </div>
        </>
      )
    }
    return (
      <div>
        <b className="component-deletesimple__title">
          ¿Estás seguro de que deseas enviar el correo de <br /> invitación a{" "}
          {userSelecteds.length} usuarios?
        </b>
        <Input.Group >
            <Form.Item style={{ width: "100%", textAlign: "left", float: "left", marginTop: "5px", fontWeight:"normal" }}>
              <Select 
                placeholder="Seleccionar idioma del correo"
                value={actual_language}
                style={{ width: "100%", textAlign: "left", float: "left",  fontWeight:"normal" }}
                onChange={handleChangeLanguage}>
                {/*  <Option value="Español">Español</Option> */}
                {props.languages?.map((language) => (
                  <Select.Option
                    key={`language-${language.id_language}`}
                    value={language.id_language}>
                    {language.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Input.Group>
      </div>
    )
  }

  return (
    <ModalCustom
      onCancel={() => props.onCancel()}
      onOk={save}
      modalOpen={props.open}
      showFooter
      disabledButton={actual_language === undefined}
      isLoadingButton={loading}>
      <div className="component-deletesimple">
        <img src={alertSvg} className="alertIcon" />
        <div className="">{header()}</div>
      </div>
    </ModalCustom>
  )
}

ModalInvite.defaultProps = { onCancel: () => { } }

export default ModalInvite
